"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildArrayFromObjectKeys = exports.hasDataThreshold2 = exports.hasDataThreshold1 = exports.isBaseData2 = exports.isBaseData = void 0;
function isBaseData(d) {
    return !Object.prototype.hasOwnProperty.call(d[0], 'd2');
}
exports.isBaseData = isBaseData;
function isBaseData2(d) {
    return Object.prototype.hasOwnProperty.call(d[0], 'd2');
}
exports.isBaseData2 = isBaseData2;
function hasDataThreshold1(p) {
    return isBaseData(p.data) && typeof p.configs.d1.threshold === 'number';
}
exports.hasDataThreshold1 = hasDataThreshold1;
function hasDataThreshold2(p) {
    return (isBaseData2(p.data) &&
        typeof p.configs.d1.threshold === 'number' &&
        typeof p.configs.d2 !== 'undefined' &&
        typeof p.configs.d2.threshold === 'number');
}
exports.hasDataThreshold2 = hasDataThreshold2;
function buildArrayFromObjectKeys(o) {
    return Object.keys(o).reduce(function (c, k) { return __spreadArray(__spreadArray([], c, true), [k], false); }, []);
}
exports.buildArrayFromObjectKeys = buildArrayFromObjectKeys;
//# sourceMappingURL=utils.js.map